import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMessage } from "../../context/MessageContext";
import { useApp } from "../../context/AppContext";
import { loginUser, lostPassword } from "../../apis/apiList/authApi";

function Header() {
  const navigate = useNavigate();
  const [isLostPass, setIsLostPass] = useState();
  const { showMessage } = useMessage();
  const { login } = useApp();
  const [isLogin, setIsLogin] = useState(false)
  const [forgotLoading, setForgotLoading] = useState(false)

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [errors, setErrors] = useState({});

  const [showScroll, setShowScroll] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrollY = window.scrollY;            
            const rootElement = document.getElementById("root");

            if (rootElement) {
                if (scrollY >= 70) {
                    rootElement.classList.add("sticky");
                } else {
                    rootElement.classList.remove("sticky");
                }
            }

            if (scrollY > 100) {
                setShowScroll(true);
            } else {
                setShowScroll(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    let newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }

    if (!formData.password) {
      newErrors.password = "Password is required";
    } else if (formData.password.length < 3) {
      newErrors.password = "Password must be at least 3 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLogin(true)

    if (validateForm()) {
      const userData = { email: formData.email, password: formData.password };
      try {
        const response = await loginUser(userData);
        if (response.success) {
          login(response.user);
          if(response.user.role == 'admin'){
            // navigate("/profile");
            navigate("/task/list");
            setIsLogin(false)
          } else {
            if(response.user.orgId){
              navigate(`/subs/org/${response.user.orgId}/projects`);
            } else {
              navigate("/select-organization");
            }
            setIsLogin(false)
          }
          showMessage("User logged in successfully", "success");
        }
      } catch (err) {
        showMessage(err?.response?.data?.message, "error");
        setIsLogin(false)
      }
    } else {
      setIsLogin(false)
    }
  };

  const validateEmail = () => {
    let newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleLostPassSubmit = async (e) => {
    e.preventDefault();
    setForgotLoading(true)
    if (validateEmail()) {
      const userData = { email: formData.email };
      try {
        const response = await lostPassword(userData);
        // console.log('response', response)
        if (response.success) {
            showMessage(response.message, 'success');
            setForgotLoading(false)
        }
      } catch (err) {
        showMessage(err?.response?.data?.message, "error");
        setForgotLoading(false)
      }
    } else {
      setForgotLoading(false)
    }
  };

  const handleLostPass = () => {
    setIsLostPass(!isLostPass);
  };

  const handleLogin = () => {
    navigate("/login");
  };

  return (
    <div>
      <header id="header">
        <div className="row ">
          <div className="header-section ">
            <div className="container">
              <div className="header-wrap ">
                <div className="logo-section ">
                  <div className="image">
                    <a
                      onClick={() => {
                        navigate("/");
                      }}
                    >
                      <img src="/images/header-logo.png" alt="header logo" />
                    </a>
                  </div>
                </div>
                <div className="login-form">
                  {/* <div className="login-form-wrap">
                    {isLostPass ? (
                      <form onSubmit={handleLostPassSubmit}>
                        <div
                          className="field username lost-pass-div"
                          style={{ marginRight: "20px" }}
                        >
                          <input
                            type="text"
                            placeholder="Email"
                            name="email"
                            required=""
                            value={formData.email}
                            onChange={handleChange}
                          />
                          {errors.email && (
                            <p className="error">{errors.email}</p>
                          )}
                          <p className="lost-password" onClick={handleLostPass}>
                            Click here for Login?
                          </p>
                        </div>

                        <div className="submit-btn">
                          {forgotLoading ? <button style={{backgroundColor: 'gray'}}>Submit</button> : <button type="submit">Submit</button>}
                        </div>
                      </form>
                    ) : (
                      <form onSubmit={handleSubmit}>
                        <div className="field username">
                          <input
                            type="text"
                            placeholder="Email"
                            name="email"
                            required=""
                            value={formData.email}
                            onChange={handleChange}
                          />
                          
                          {errors.email && (
                            <p className="error">{errors.email}</p>
                          )}
                        </div>
                        <div>
                          <div className="field password lost-pass-div">
                            <input
                              type="password"
                              placeholder=" Password"
                              name="password"
                              required=""
                              value={formData.password}
                              onChange={handleChange}
                            />
                            {errors.password && (
                              <p className="error">{errors.password}</p>
                            )}
                          </div>
                          <p className="lost-password" onClick={handleLostPass}>
                            Lost password?
                          </p>
                        </div>

                        <div className="submit-btn">
                          {isLogin ? <button disabled style={{backgroundColor: 'grey'}}>Login</button> : <button type="submit">Login</button> }
                        </div>
                      </form>
                    )}
                    
                  </div> */}
                  <div className="login-form-wrap submit-btn">
                    <button type="submit" onClick={handleLogin}>Login</button>
                  </div>
                </div>
                <div className="call-section">
                  <div className="phone-no">
                    <a href="tel:(800) 820-6020">(800) 820-6020</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}

export default Header;
